import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "space-y-3 text-sm"
};
const _hoisted_2 = {
  class: "text-slate-700"
};
const _hoisted_3 = {
  key: 0,
  class: "ml-1 rounded bg-amber-100 px-1 text-xs text-amber-700"
};
const _hoisted_4 = {
  key: 1,
  class: "text-xs text-slate-400"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "font-medium"
};
const _hoisted_7 = {
  class: "text-xs text-slate-400"
};
const _hoisted_8 = {
  class: "text-slate-700"
};
const _hoisted_9 = {
  key: 0,
  class: "rounded bg-amber-100 px-1 text-xs text-amber-700"
};
const _hoisted_10 = {
  class: "mt-1 font-medium text-slate-800"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "font-medium"
};
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  key: 2,
  class: "ml-1 rounded bg-red-100 px-1 text-red-600"
};
const _hoisted_17 = {
  key: 3
};
import { computed } from 'vue';
export default {
  __name: 'PlanSections',
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const evaluation = computed(() => props.plan.evaluation || {});
    const RESULT_TEXT = {
      SATISFIED: '满足',
      GAP: '不满足',
      NEEDS_REVIEW: '待复核',
      REJECTED: '否决'
    };
    function resultText(r) {
      return RESULT_TEXT[r] || r;
    }
    function resultClass(r) {
      if (r === 'SATISFIED') return 'bg-emerald-50 text-emerald-700';
      if (r === 'NEEDS_REVIEW') return 'bg-amber-50 text-amber-700';
      return 'bg-red-50 text-red-700';
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", null, [_cache[0] || (_cache[0] = _createElementVNode("p", {
        class: "mb-1 font-semibold text-slate-700"
      }, "判定明细", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(evaluation.value.items || [], item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.code,
          class: "flex items-start gap-2 py-0.5"
        }, [_createElementVNode("span", {
          class: _normalizeClass(["status-badge mt-0.5 shrink-0", resultClass(item.result)])
        }, _toDisplayString(resultText(item.result)), 3), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_2, _toDisplayString(item.description || item.code), 1), item.result === 'NEEDS_REVIEW' ? (_openBlock(), _createElementBlock("span", _hoisted_3, "需人工复核")) : _createCommentVNode("", true), item.detail ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.detail), 1)) : _createCommentVNode("", true)])]);
      }), 128))]), (__props.plan.gaps || []).length ? (_openBlock(), _createElementBlock("section", _hoisted_5, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "mb-1 font-semibold text-slate-700"
      }, "差距与补齐", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.gaps, g => {
        return _openBlock(), _createElementBlock("div", {
          key: g.gap_no,
          class: "py-0.5 text-slate-600"
        }, [_createElementVNode("span", _hoisted_6, _toDisplayString(g.gap_no), 1), _createTextVNode(" " + _toDisplayString(g.description) + " ", 1), _createElementVNode("span", _hoisted_7, "（" + _toDisplayString(g.quantified) + "）", 1)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("section", null, [_cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "mb-1 font-semibold text-slate-700"
      }, "服务产品与报价", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.product_matches || [], m => {
        return _openBlock(), _createElementBlock("div", {
          key: m.gap_no + m.product_code,
          class: "flex items-center gap-2 py-0.5"
        }, [_createElementVNode("span", _hoisted_8, _toDisplayString(m.product_name), 1), m.needs_confirm ? (_openBlock(), _createElementBlock("span", _hoisted_9, "LLM 匹配·待确认")) : _createCommentVNode("", true)]);
      }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.quotation || [], q => {
        return _openBlock(), _createElementBlock("div", {
          key: q.product_code,
          class: "py-0.5 text-slate-600"
        }, _toDisplayString(q.product_name) + "：¥" + _toDisplayString(q.estimated_price_cny), 1);
      }), 128)), _createElementVNode("p", _hoisted_10, "合计：¥" + _toDisplayString(__props.plan.quotation_total), 1)]), (__props.plan.timeline || []).length ? (_openBlock(), _createElementBlock("section", _hoisted_11, [_cache[3] || (_cache[3] = _createElementVNode("p", {
        class: "mb-1 font-semibold text-slate-700"
      }, "时间线", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.timeline, t => {
        return _openBlock(), _createElementBlock("div", {
          key: t.phase,
          class: "py-0.5 text-slate-600"
        }, [_createElementVNode("span", _hoisted_12, _toDisplayString(t.phase) + "（" + _toDisplayString(t.period) + "）", 1), _createTextVNode("：" + _toDisplayString((t.items || []).join('；')), 1)]);
      }), 128))])) : _createCommentVNode("", true), (__props.plan.evidences || []).length ? (_openBlock(), _createElementBlock("section", _hoisted_13, [_cache[4] || (_cache[4] = _createElementVNode("p", {
        class: "mb-1 font-semibold text-slate-700"
      }, "政策依据", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.evidences, (e, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "py-0.5 text-xs text-slate-500"
        }, [e.url ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: e.url,
          target: "_blank",
          rel: "noopener",
          class: "text-primary-600 underline"
        }, _toDisplayString(e.publisher || e.url), 9, _hoisted_14)) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(e.publisher || e.ref), 1)), _createElementVNode("span", null, "（" + _toDisplayString(e.publish_date || '日期不详') + "）", 1), !e.verified ? (_openBlock(), _createElementBlock("span", _hoisted_16, "未验证来源")) : _createCommentVNode("", true)]);
      }), 128))])) : _createCommentVNode("", true), (__props.plan.warnings || []).length ? (_openBlock(), _createElementBlock("section", _hoisted_17, [_cache[5] || (_cache[5] = _createElementVNode("p", {
        class: "mb-1 font-semibold text-slate-700"
      }, "警告", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plan.warnings, (w, i) => {
        return _openBlock(), _createElementBlock("p", {
          key: i,
          class: "py-0.5 text-xs text-amber-600"
        }, _toDisplayString(w), 1);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};